"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _components = require("../components");
var _PaginationFooter = _interopRequireDefault(require("./PaginationFooter"));
var _Pagination = require("./Pagination.hooks");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Pagination(props) {
  var location = (0, _reactRouterDom.useLocation)();
  var query = (0, _react.useMemo)(function () {
    return new URLSearchParams(location.search);
  }, [location]);
  var children = props.children,
    onChangedPageSize = props.onChangedPageSize;
  var page = (0, _Pagination.initialPage)(query);
  var pageSize = (0, _Pagination.initialPageSize)(query);
  var variant = (0, _react.useMemo)(function () {
    return props.variant;
  }, [props]);
  (0, _react.useEffect)(function () {
    onChangedPageSize(page, pageSize);
  }, [page, pageSize, onChangedPageSize]);
  if (variant === 'embeded') {
    return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 12
    }, children), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
      pl: 2
    }, /*#__PURE__*/_react["default"].createElement(_PaginationFooter["default"], Object.assign({
      query: query
    }, props)))));
  }
  return /*#__PURE__*/_react["default"].createElement(_components.Surface, Object.assign({
    footerActions: /*#__PURE__*/_react["default"].createElement(_PaginationFooter["default"], Object.assign({
      query: query
    }, props))
  }, props), children);
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Pagination);